///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";

import NotificationList from "../components/notifications/NotificationList";
import Loader from "../components/notifications/Loader";
import SystemError from "../components/SystemError";
import SystemErrorModal from "../components/SystemErrorModal";
import {
  fetchNotifications,
  markAllAsRead,
  markAllAsReadReset
} from "../slices/notificationsSlice";
import Spinner from "../components/icons/Spinner";
import messages from "../helpers/messages";

const Notifications = () => {
  const dispatch = useDispatch();
  const { isFetching, isFailure, notifications, markAsRead } = useSelector(
    state => state.notifications
  );
  const { role } = useSelector(state => state.user);

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  const reloadPage = () => {
    dispatch(fetchNotifications());
  };

  const unreadNotifications = notifications.filter(
    x => x.isPreviouslySeenByUser === false
  );
  return (
    <>
      {isFailure ? (
        <SystemError reloadPage={reloadPage} />
      ) : (
        <>
          <SystemErrorModal
            open={markAsRead.isFailure}
            handleTryAgain={() => dispatch(markAllAsRead())}
            closeModal={() => dispatch(markAllAsReadReset())}
            handleExit={() => dispatch(markAllAsReadReset())}
          />
          <div
            data-testid="notifications"
            className="p-24 page-container notifications"
          >
            <>
              <div className="one-whole mb-24">
                <div className="grid__cell one-half">
                  <h1>
                    <FormattedMessage
                      {...messages.notificationsCount}
                      values={{ noOfNotifications: unreadNotifications.length }}
                    />
                  </h1>
                </div>
                <div className="grid__cell one-half text-right">
                  <button
                    className="text-button univers-67-bold-cond font-size-14 uppercase px-12"
                    data-testid="mark-read"
                    onClick={() => dispatch(markAllAsRead())}
                    disabled={
                      !unreadNotifications || !unreadNotifications.length
                    }
                    style={{ minWidth: 140 }}
                  >
                    {markAsRead.isSaving ? (
                      <Spinner
                        className="box-content spinner"
                        height="14px"
                        width="14px"
                        fill="#0088D1"
                      />
                    ) : (
                      messages.markAllAsRead.defaultMessage
                    )}
                  </button>
                </div>
              </div>
              {isFetching ? (
                <Loader />
              ) : (
                <NotificationList notifications={notifications} role={role} />
              )}
            </>
          </div>
        </>
      )}
    </>
  );
};

export default Notifications;
